import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import ListElement from '../ListElement';

const ListElementDraggable = ({
  id,
  name,
  nameCaption,
  label,
  isSelected,
  onSelect,
  disabledTooltipContent,
  isFrom,
  onDragEnd,
  multipleDragged,
  count,
  hidden,
}) => {
  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: isFrom ? 'from' : 'to',
    item: { id, name, nameCaption, label, multipleDragged, count, isSelected, isFrom },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        onDragEnd({ id, name, nameCaption, label });
      }
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  }), [multipleDragged, count, isSelected]);

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  });

  return (
    <ListElement
      {
        ...{
          id,
          name,
          nameCaption,
          label,
          isSelected,
          onSelect,
          disabledTooltipContent,
          drag,
          isDragging: isDragging || hidden,
        }
      }
    />
  );
};

ListElementDraggable.defaultProps = {
  onDragEnd: () => {},
  count: 0,
};

export default ListElementDraggable;
